import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { CardContent, CardMedia } from '@mui/material';

import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { Event } from 'api/event';
import { Card, Title } from 'common';

import { useLanguage } from '../../../context/LanguageContext';

interface EventCardProps {
    eventsItem: Event;
}


export const EventCard = ({ eventsItem }: EventCardProps) => {
    const { language } = useLanguage();
    return (
        <Link to={`/events/${eventsItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {eventsItem.images && eventsItem.images.length > 0 && eventsItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={eventsItem.images[0].photo}
                        alt={eventsItem.title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // количество строк, для отображения
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {eventsItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{
                            __html: eventsItem[`description_${language}`]
                        }} />
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(eventsItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
